/* eslint-disable @typescript-eslint/indent */
/* eslint-disable @typescript-eslint/member-delimiter-style */
import { createContext } from 'preact-compat'
import { Module } from '../services/modules'

type GlobalType = string | string[]

interface GlobalVars extends Record<string, GlobalType> {
  communityId: string
  eventLogger: string
  basePath: string
  cssLink: string
  communityUrl: string
  communityLanguage: string
  activeModules: Module[]
}

const vars: GlobalVars = {
  communityId: '',
  eventLogger: '',
  basePath: '',
  cssLink: '',
  communityUrl: '',
  communityLanguage: '',
  activeModules: []
}

function globals<T extends keyof GlobalVars>(name: T, value: GlobalVars[T] = ''): GlobalVars[T] {
  if (!value) {
    return vars[name] || ''
  }

  vars[name] = value

  return vars[name] || ''
}

export default globals

type Event<N extends string, T> = Record<N, T>

type GlobalEvents = Event<'quote', { username: string; content: string }> &
  Event<'edit_column', { editing: boolean }> &
  Event<'title_changed', { title: string }> &
  Event<'control_sidebar_state', { isOpen: boolean }> &
  Event<'posts_marked_as_spam', {}> &
  Event<'posts_marked_as_not_spam', {}> &
  Event<'posts_permanently_deleted_spam', {}> &
  Event<'productboard_note_created', { url: string | null; id: string }> &
  Event<'zendesk_ticket_created', { url: string | null; id: string }> &
  Event<'salesforce_case_created', { url: string | null; id: string }> &
  Event<'freshdesk_ticket_created', { url: string | null; id: string }> &
  Event<'intercom_conversation_created', { url: string | null; id: string }> &
  Event<'post_editor_submit', { content: string }> &
  Event<'edit_cookie_settings', null>

type Subscription = [string, (payload: any) => void]

const subscriptions: Subscription[] = []

export type UnsubscribeCallback = () => void

export function subscribe<T extends keyof GlobalEvents>(
  eventName: T,
  callback: (payload: GlobalEvents[T]) => void | Promise<void>
): UnsubscribeCallback {
  const subscription: Subscription = [eventName, callback]
  subscriptions.push(subscription)
  return () => {
    subscriptions.splice(subscriptions.indexOf(subscription), 1)
  }
}

export function publish<T extends keyof GlobalEvents>(name: T, payload: GlobalEvents[T]) {
  if (process.env.NODE_ENV === 'development') {
    console.log('published', name, 'with the payload of', payload)
  }
  subscriptions.forEach((subscription) => {
    if (subscription[0] === name) {
      try {
        subscription[1](payload)
      } catch (err) {
        console.error(err)
      }
    }
  })
}

const defaultModules: Module[] = []
export const ModulesContext = createContext(defaultModules)
